<template>
  <div
    v-if="(editMode || dgRowInEditMode[gridId + '.' + rowKey]) && !controlInfo.readonly"
    @keydown.enter="openDatepicker"
    @keydown.esc="closeDatepicker"
    class="data-grid__dateCell"
  >
    <b-input-group>
      <b-input-group-prepend class="toggle-wrapper" is-text>
        <button class="toggle-calendar" type="button" title="Toggle" data-toggle>
          <icon name="calendar" />
        </button>
      </b-input-group-prepend>
      <flat-pickr
        :config="{
          wrap: true,
          allowInput: true,
          formatDate: formatDate
        }"
        v-model.trim="$v.value.$model"
        :class="{ 'is-invalid': $v.value.$error }"
        class="form-control datepicker"
        :readonly="controlInfo.readonly"
        @on-change="save"
      />
      <b-form-invalid-feedback v-if="!$v.value.required">{{ controlInfo.label }} is required</b-form-invalid-feedback>
      <b-input-group-append v-if="value && !controlInfo.readonly">
        <b-button variant="danger" size="sm" @click="remove">
          <icon name="remove" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
  <div v-else>
    <span v-if="cellVal">{{ cellDisplayVal }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { requiredIf } from 'vuelidate/lib/validators'
// services
import db from '@/services/db'
// helpers
import utils from '@/helpers/utils'

export default {
  props: [
    'rowKey',
    'cellKey',
    'cellVal',
    'cellDisplayVal',
    'options',
    'gridId',
    'widgetKey',
    'editMode',
    'controlInfo',
  ],
  data() {
    return {
      rowInst: null,
      value: null,
    }
  },
  watch: {
    cellVal(value) {
      this.value = value ? new Date(value) : null
    },
  },
  computed: {
    ...mapState(['dgRowInEditMode']),
    isRequired() {
      return this.controlInfo.required
    },
  },
  methods: {
    formatDate: utils.formatDate,
    save(value) {
      if (this.controlInfo.readonly) return
      if (!value.length) return

      const data = {
        options: this.options,
        rowKey: this.rowKey,
        cellKey: this.cellKey,
        value: Date.parse(value),
      }

      if (this.options.isReactive || typeof this.options.isReactive === 'undefined') {
        db.dataGrid.data.saveCellVal(data)
      } else {
        const rowInst = this.$instByClass(this, 'data-grid__row')

        rowInst.rowData[this.cellKey] = Date.parse(value)
      }
    },
    remove() {
      const data = {
        options: this.options,
        rowKey: this.rowKey,
        cellKey: this.cellKey,
        value: null,
      }

      if (this.options.isReactive || typeof this.options.isReactive === 'undefined') {
        db.dataGrid.data.saveCellVal(data)
      } else {
        const rowInst = this.$instByClass(this, 'data-grid__row')

        rowInst.rowData[this.cellKey] = null
        this.value = null
      }
    },
  },
  created() {
    this.value = this.cellVal ? new Date(this.cellVal) : null

    this.$nextTick(() => {
      this.rowInst = this.$instByClass(this, 'data-grid__row')
    })
  },
  beforeDestroy() {
    this.rowInst = null
    this.value = null
  },
  validations: {
    value: {
      required: requiredIf('isRequired'),
    },
  },
}
</script>

<style>
.data-grid__dateCell {
  min-width: 170px;
}
.toggle-calendar {
  padding: 0;
  border: 0;
  margin: 0;
  background: none;
}
.toggle-wrapper {
  height: 40px;
}
</style>